var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatkaFun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.256 137.748C126.335 138.253 127.554 138.309 128.668 137.91H128.675C129.796 137.503 130.7 136.69 131.198 135.611C131.702 134.539 131.744 133.334 131.338 132.22L128.143 123.349C127.659 123.818 127.134 124.26 126.629 124.715C126.419 124.905 126.216 125.094 126.005 125.276C125.361 125.851 124.716 126.425 124.043 126.972C123.104 127.742 122.137 128.499 121.149 129.221C121.058 129.291 120.974 129.361 120.883 129.431L122.978 135.226C123.385 136.34 124.19 137.23 125.262 137.735L125.256 137.748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3326 137.91C22.4538 138.316 23.666 138.26 24.752 137.749C25.8241 137.244 26.637 136.354 27.0363 135.24L29.1314 129.445C29.0403 129.375 28.9563 129.305 28.8652 129.235C27.8772 128.506 26.9103 127.764 25.9712 126.986C25.2985 126.432 24.6539 125.865 24.0091 125.29C23.7989 125.101 23.5887 124.912 23.3855 124.73C22.881 124.274 22.3554 123.833 21.8719 123.363L18.6768 132.22C18.2704 133.348 18.3124 134.554 18.8169 135.619C19.3215 136.698 20.2184 137.511 21.3394 137.917L21.3326 137.91Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.783 31.5777H28.4163C15.8876 44.0153 9 60.5515 9 78.287C9 112.755 36.7558 137.77 75 137.77C113.244 137.77 141 112.755 141 78.287C141 60.552 134.112 44.0089 121.584 31.5777H119.783ZM75 128.962C47.4559 128.962 17.8077 113.105 17.8077 78.287C17.8077 76.7384 19.0619 75.4841 20.6105 75.4841C22.1591 75.4841 23.4133 76.7384 23.4133 78.287C23.4133 109.252 50.152 123.357 75 123.357C76.5486 123.357 77.8028 124.611 77.8028 126.16C77.8028 127.708 76.5486 128.962 75 128.962Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2488 12V12.6587C14.2488 20.0022 21.4171 25.9722 30.2179 25.9722H119.783C128.591 25.9722 135.752 20.0022 135.752 12.6587V12H14.2488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatkaFun);
export default __webpack_public_path__ + "static/media/matka-fun.ba6aeee6c49f2cc17015c3e1b2ef80b1.svg";
export { ForwardRef as ReactComponent };